// extracted by mini-css-extract-plugin
export default {"responsiveHeader":"PollAnswerTable_responsiveHeader__HVNW+"};